import { render, staticRenderFns } from "./AMSilkGlassCP1919FABE.vue?vue&type=template&id=0c89de3c&scoped=true"
import script from "./AMSilkGlassCP1919FABE.vue?vue&type=script&lang=ts"
export * from "./AMSilkGlassCP1919FABE.vue?vue&type=script&lang=ts"
import style0 from "./AMSilkGlassCP1919FABE.vue?vue&type=style&index=0&id=0c89de3c&prod&lang=scss&scoped=true"
import style1 from "./AMSilkGlassCP1919FABE.vue?vue&type=style&index=1&id=0c89de3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c89de3c",
  null
  
)

export default component.exports